import React from 'react';
import { useDrag } from 'react-dnd';
import QuestionCard from './QuestionCard';

const DraggableQuestionCard = ({ question, onSelect, onDeselect, isSelected, disableSelect }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'question',
        item: { question },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));

    return (
        <div 
            ref={drag} 
            style={{ 
                opacity: isDragging ? 0.5 : 1,
                cursor: 'move'
            }}
        >
            <QuestionCard 
                question={question}
                onSelect={onSelect}
                onDeselect={onDeselect}
                isSelected={isSelected}
                disableSelect={disableSelect}
            />
        </div>
    );
};

export default DraggableQuestionCard;